/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2015, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery',
	'../lib/@waca/core-client/js/core-client/ui/core/Class',
	'../nls/StringResources',
	'../lib/@ba-ui-toolkit/ba-graphics/dist/icons-js/warning_16',
	'doT',
	'text!./templates/MoreDataIndicator.template'
], function($, Class, stringResources, warn_24, dot, MoreDataIndicatorTemplate) {

	var moreDataIndicatorTemplate = dot.template(MoreDataIndicatorTemplate);

	/**
	 * The more data indicator displays informational text to the user in the event that the query result contains
	 * more than the threshold number of rows.
	 */
	var MoreDataIndicator = Class.extend({

		init: function(queryThreshold) {
			this._visView = null;
			this._updateMessage(queryThreshold);
		},

		_updateMessage: function(queryThreshold) {
			//Create the localized text content....
			var moreDataMessage = stringResources.get('moreDataIndicator', { threshold: queryThreshold });
			this.$moreData = $(moreDataIndicatorTemplate({ value: moreDataMessage, warn: warn_24.default }));
		},

		/**
		 * Called when data is refreshed to either show or hide the 'Data was clipped' indicator.
		 * @param hasMoreData - true if the 'Data was clipped' indicator should be shown
		 * @param visView - the up-to-date view to add the indicator to.
		 * @param queryThreshold - the new query threshold
		 */
		update: function(hasMoreData, visView, queryThreshold) {
			this._updateMessage(queryThreshold);

			if (visView !== this._visView) {
				//Make sure the view is always up-to-date.
				this._visView = visView;
				visView.visModel.ownerWidget.addIcon(this.$moreData, 'moreDataIndicator');

			}

			//There is a hidden style on the indicator unless there actually is an overflow.
			if (hasMoreData) {
				this.$moreData.removeClass('dataWidgetNoMoreData');
				visView.$el.addClass('dwMoreData');
			} else {
				this.$moreData.addClass('dataWidgetNoMoreData');
				visView.$el.removeClass('dwMoreData');
			}
		}
	});

	return MoreDataIndicator;
});
